module.exports = __webpack_public_path__ + "static/media/intro-es-de.b603744c.vtt";